import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import ListIcons from "../../../../Components/UI/ListIcons";

const listFormatTabs = (props) => {
  const gridViewType = [
    { type: 'Table', name: 'Table view', svgIcon: 'IconListView' },
    { type: 'Grid', name: 'Grid view', svgIcon: 'KanbanView' },
  ];

  // Logic for selecting and formatting dropdown list items
  const selectedTypeObj = gridViewType.find((grid) => grid.type === props.ListingType); // Use find for efficient object matching
  const dropDownList = gridViewType.map((grid) => {
    const isActive = props.ListingType === grid.type;
    return {
      clickHandler: () => props.assignListingType(grid.type),
      svgIcon: grid.svgIcon,
      name: grid.name,
      active: isActive,
    };
  });

  return (
    <Wrp>
      <div className="ml-md-auto py-2 py-md-0 btn-group">
        <ListIcons dropDownList={dropDownList} selectedTypeObj={selectedTypeObj} activeView={selectedTypeObj.type} />
      </div>
    </Wrp>
  );
};

export default listFormatTabs;